export enum SelfResponsePriority {
  medium = 'Medium',
  high = 'High',
  none = 'None'
}